<template>
  <TwoColumnQuizReviewLayout>
    <template #responses>
      <ResponseItem
        :key="response.id"
        :option="response"
        :showCheckMarkIcon="true"
        :class="{
          'correct': response.correct,
          'incorrect': !response.correct,
        }"
      />
    </template>
    <template #answers>
      <ResponseItem
        :key="answer.id"
        :option="answer"
        :showCheckMarkIcon="false"
      />
    </template>
    <template #otherCorrect v-if="otherCorrect && otherCorrect.length > 0">
      <ResponseItem
        v-for="(option) in otherCorrect"
        :key="option.id"
        :option="option"
        :showCheckMarkIcon="false"
      />
    </template>
  </TwoColumnQuizReviewLayout>
</template>

<script>
import TwoColumnQuizReviewLayout from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/TwoColumnQuizReviewLayout.vue'
import ResponseItem from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/ResponseItem.vue'

export default {
  components: {
    ResponseItem,
    TwoColumnQuizReviewLayout,
  },
  props: {
    dataAnswer: {
      type: Object,
      default: () => {
      },
    },
  },
  computed: {
    answer() {
      return {
        title: this.dataAnswer?.slideDetails?.correctQuizTypeAnswer,
      }
    },
    response() {
      return {
        title: this.dataAnswer?.Answer?.typeAnswer,
        correct: this.dataAnswer?.Answer?.correct,
      }
    },
    otherCorrect() {
      return JSON.parse(this.dataAnswer?.slideDetails?.otherCorrectQuiz)
    },
  },
}
</script>
